import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { AlarisDialogComponent } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-confirm-close-dialog',
	templateUrl: './dialog-close.component.html',
	styleUrl: './dialog-close.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AlarisDialogComponent, TranslateModule],
})
export class AitcConfirmCloseDialogComponent {
	constructor(
		private readonly dialogRef: DialogRef<boolean>
	) {}

	confirm(): void {
		this.dialogRef.close(true);
	}

	close(): void {
		this.dialogRef.close(false);
	}
}
